import type { CartaoProjecaoTransferenciaProps } from "./types-cartao-projecao-transferencia";
import { useCartaoProjecaoTransferencia } from "./use-cartao-projecao-transferencia";
import { CartaoProjecaoTransferenciaView } from "./view-cartao-projecao-transferencia";

export function CartaoProjecaoTransferencia(props: CartaoProjecaoTransferenciaProps) {
  const vm = useCartaoProjecaoTransferencia(props);

  return <CartaoProjecaoTransferenciaView {...vm} />;
}

export type * from "./types-cartao-projecao-transferencia";
